import { render, staticRenderFns } from "./ChangeDepartmentConfirm.vue?vue&type=template&id=f6da5e1e&"
import script from "./ChangeDepartmentConfirm.vue?vue&type=script&lang=ts&"
export * from "./ChangeDepartmentConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports